import { create } from 'zustand';

/** Measured frame statistics. `null` means "not measured (yet)" — values are never faked. */
export interface FrameStats {
  readonly fps: number;
  readonly frameTimeMs: number;
}

export interface DeveloperState {
  readonly visible: boolean;
  readonly frameStats: FrameStats | null;
  setVisible: (visible: boolean) => void;
  toggle: () => void;
  setFrameStats: (stats: FrameStats | null) => void;
}

export const useDeveloperStore = create<DeveloperState>()((set) => ({
  visible: false,
  frameStats: null,
  setVisible: (visible) => set(visible ? { visible } : { visible, frameStats: null }),
  toggle: () =>
    set((state) => (state.visible ? { visible: false, frameStats: null } : { visible: true })),
  setFrameStats: (frameStats) => set({ frameStats }),
}));
